import React, { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import '../../../css/GenericServices/ServiceSelectionGS.css';
import Header from '../../Shared/Header';
import Footer from '../../Shared/Footer';
import Footer2 from '../../Shared/Footer2';
import quotationHistory from '../../../Assets/MarketPlace/quotationHistory.svg';
import rightarrow from '../../../Assets/ContainerStatus/Assets_Desktop/arrow-right-red.svg';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import TitleDescription from '../../../Data/Shared/TitleDescription.json';
const ServiceSelectionGS = props => {
    let history = useHistory();
    let [serviceSelectionData, setServiceSelectionData] = useState([]);
    let [serviceRequestHistory, setServiceRequestHistory] = useState(true);
    serviceSelectionData = [
        { id: "1", name: "Clearing & Forwarding Service" },
        { id: "2", name: "Container Repair Service" },
        { id: "3", name: "Container Storage Service" },
    ];
    const onHandleCard = (event) => {
        history.push("/");
    }
    const serviceRequestHistoryFunction = () => {
        setServiceRequestHistory(!serviceRequestHistory);
    }
    return (
        <div class="csoutercolor">
            <MetaDecorator title={TitleDescription.ServiceSelectionGSTitle} description={TitleDescription.ServiceSelectionGSDescription} />
            <Header tilesFetched={() => { }} />
            <div class="csnofullServiceSelection">
                <div id="csnobox1ServiceSelection">
                    <nav class="ServiceSelectionNavBar">
                        <div className="ServiceSelectionNavBarHeading">
                            <small id="ServiceSelectionNavBarHeadingValue"> Select Service Type</small>
                        </div>
                        <div id="ServiceSelectionGSAcceptMobile" className="ServiceSelectionGSNavbarNameRight">
                            <a><img src={quotationHistory} class=" mr-1 pb-1" id="ServiceSelectionNavBarRightHeadingImg" alt="" loading="lazy" />
                                <small
                                    class={serviceRequestHistory ? "ServiceSelectionGSNavbarRightText" : "ServiceSelectionGSNavbarGrayRightText"}
                                    onClick={serviceRequestHistoryFunction}>
                                    Update Service Request
                                </small>
                            </a>
                        </div>
                    </nav>
                    <hr class="hr1" />
                    <>
                        <nav class="ServiceSelectionGSMobileNavbar">
                            <div className="ServiceSelectionGSNavbarNameRight">
                                <a><img src={quotationHistory} class=" mr-1 pb-1" id="ServiceSelectionNavBarRightHeadingImg" alt="" loading="lazy" />
                                    <small
                                        class={serviceRequestHistory ? "ServiceSelectionGSNavbarRightText" : "ServiceSelectionGSNavbarGrayRightText"}
                                        onClick={serviceRequestHistoryFunction}>
                                        Update Service Request
                                    </small>
                                </a>
                            </div>
                        </nav>
                    </>
                    <div class="toppartServiceSelection">
                        <div class="ServiceSelectionOuterContainerDiv">
                            <div class="ServiceSelectionLeftOuterDiv">
                                {(serviceSelectionData.map((name, index) => {
                                    return (
                                        <div class="ServiceSelectionLeftSideDiv" key={index} onClick={() => onHandleCard(index)}>
                                            {index < (serviceSelectionData.length / 2) &&
                                                <>
                                                    <div class="ServiceSelectionWhiteContainerdiv">
                                                        <div class="ServiceSelectionLeftPartNumberDiv">
                                                            <small class="ServiceSelectionLeftPartNumber">{name.id}</small>
                                                        </div>
                                                        <div class="ServiceSelectionRightPartContainerDiv">
                                                            <small class="ServiceSelectionHeading">{name.name}</small>
                                                            <div class="ServiceSelectionArrowDiv">
                                                                <img src={rightarrow} id="ServiceSelectionRightArrowImg" height="15" width="16" class="" alt="" loading="lazy" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            }
                                        </div>
                                    );
                                }))}
                            </div>
                            <div class="ServiceSelectionLeftOuterDiv">
                                {(serviceSelectionData.map((name, index) => {
                                    return (
                                        <div class="ServiceSelectionRightSideDiv" key={index} onClick={() => onHandleCard(index)}>
                                            {index >= (serviceSelectionData.length / 2) &&
                                                <>
                                                    <div class="ServiceSelectionWhiteContainerdiv">
                                                        <div class="ServiceSelectionLeftPartNumberDiv">
                                                            <small class="ServiceSelectionLeftPartNumber">{name.id}</small>
                                                        </div>
                                                        <div class="ServiceSelectionRightPartContainerDiv">
                                                            <small class="ServiceSelectionHeading">{name.name}</small>
                                                            <div class="ServiceSelectionArrowDiv">
                                                                <img src={rightarrow} id="ServiceSelectionRightArrowImg" height="15" width="16" class="" alt="" loading="lazy" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            }
                                        </div>
                                    );
                                }))}
                            </div>
                        </div>
                        <div class="ServiceSelectionLowerNoteDiv">
                            <small class="ServiceSelectionLowerNote">Please contact <small class="ServiceSelectionRedNote">Customer Support</small> to add new service here.</small>
                        </div>
                    </div>
                </div>
            </div>
            <div class="cs2footer11ServiceSelection">
                <Footer />
            </div>
            <div class="cs2footer22ServiceSelection">
                <Footer2 />
            </div>
        </div>
    );
};
export default ServiceSelectionGS;